import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';

import { useCurrentScope } from '../../../shared/scope/useCurrentScope.js';
import {
  getDashboardBriefing,
  getDashboardBriefingQueryKey,
  type ManagerBriefing,
} from '../api/dashboard.client.js';

export function useManagerBriefing(): UseQueryResult<ManagerBriefing> {
  const scope = useCurrentScope();
  const workspaceId = scope?.workspaceId;

  return useQuery({
    queryKey: workspaceId
      ? getDashboardBriefingQueryKey(workspaceId)
      : ['dashboard', 'no-workspace', 'briefing'],
    queryFn: () => getDashboardBriefing(),
    retry: false,
    enabled: Boolean(workspaceId),
  });
}
